<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button type="primary" icon="export" @click="exportData" :loading="exportLoading">导出</a-button>
				<a-button type="primary" v-if="query.pfoutCheckInId > 0 && query.pfoutCheckOutId == 0"
				 :disabled="!tableSelectedRows || tableSelectedRows.length === 0" icon="close" @click="batchCancel">
				 批量作废
				</a-button>
				<a-button type="primary" v-if="query.pfoutCheckOutId > 0 && query.pfoutCheckInId == 0"
				 :disabled="!tableSelectedRows || tableSelectedRows.length === 0" icon="rollback" style="margin-left: 8px;" @click="batchBack">
				 批量退回
				</a-button>
			</div>
		</div>
        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="票号详情">
                <div style="display: flex;justify-content: space-between;">
                    <div style="width: 30%;display: flex;align-items: center;">
                        <div style="width: 120px;">状态:</div>
                        <a-select v-model="query.pfoutDetailsState" placeholder="请选择状态" style="width: 100%;">
							<a-select-option value="">全部</a-select-option>
                            <a-select-option v-for="(item,index) in pfoutDetailsStateList" :value="item.pfoutDetailsState" :key="index">{{item.pfoutDetailsStateName}}</a-select-option>
                        </a-select>
                    </div>
                    <div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
                        <a-button type="primary" icon="search" @click="apiPfoutDetailsQueryList">查询</a-button>
                    </div>
                </div>
            </a-collapse-panel>
        </a-collapse>
		<div class="qinang-card">
            <div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						{{pfoutDetailsMain[0].pflibraryName}}
					</a-breadcrumb-item>
					<a-breadcrumb-item>
						{{pfoutDetailsMain[1].productName}}
					</a-breadcrumb-item>
				</a-breadcrumb>
				<div>
					<a-tooltip placement="bottomRight">
						<template slot="title">
						  <span>返回上一级</span>
						</template>
						<a-button type="link" @click="backToUpPage"><i class="icon-sjp-fanhui"></i></a-button>
					</a-tooltip>
				</div>
			</div>
         
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="pfoutDetailsId" :loading="tableLoading" :pagination="false">
				<span slot="createTime" slot-scope="createTime">
                    {{moment(createTime.createTime).format('YYYY-MM-DD HH:mm:ss')}}
				</span>
                <span slot="claimTime" slot-scope="claimTime">
                    {{claimTime.claimTime?moment(claimTime.claimTime).format('YYYY-MM-DD HH:mm:ss'):'未激活'}}
                </span>
                <span slot="pfoutDetailsState" slot-scope="pfoutDetailsState">
                    {{pfoutDetailsStateList.find(item => item.pfoutDetailsState == pfoutDetailsState.pfoutDetailsState)?.pfoutDetailsStateName || '-'}}
                </span>
                <span slot="operation" slot-scope="operation">
                    <a-button v-if="operation.pfoutDetailsState == 1 && query.pfoutCheckOutId == 0" type="primary" size="small" @click="tableCancel(operation)">作废</a-button>
                    <a-button v-if="operation.pfoutDetailsState == 2 && query.pfoutCheckInId == 0" icon="rollback" type="primary" size="small" @click="tableBack(operation)">退回</a-button>

                </span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'
	import axios from 'axios'

	export default {
		data() {
			return {
				moment,
                pfoutDetailsMain: JSON.parse(window.sessionStorage.getItem('pfoutDetailsMain')),
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				pfoutDetailsStateList: [
					{pfoutDetailsState:'1', pfoutDetailsStateName:'待出库'},
                    {pfoutDetailsState:'2', pfoutDetailsStateName:'待激活'},
                    {pfoutDetailsState:'3', pfoutDetailsStateName:'已激活'},
					{pfoutDetailsState:'-1', pfoutDetailsStateName:'已作废'},
                ],
				pfoutId: '',
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					pfoutLogState: undefined,
					pfoutId: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
					{ title:'票号', dataIndex:'ticketNumber', key:'ticketNumber', align:'center'},
					{ title:'状态', key:'pfoutDetailsState', align:'center', scopedSlots:{customRender:'pfoutDetailsState'}},
					{ title:'入库时间',  key:'createTime', align:'center', scopedSlots:{customRender:'createTime'}},
					{ title:'激活时间',  key:'claimTime', align:'center', scopedSlots:{customRender:'claimTime'}},
					{ title:'操作', key:'operation', align:'center', scopedSlots:{customRender:'operation'}},
				],
				tableLoading: false,
				tableSelectedRows: [],
				//搜索+表格-end
				exportLoading: false,
			};
		},
		methods: {

			//表格开始-搜索
			async apiPfoutDetailsQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfoutDetailsQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiPfoutDetailsQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiPfoutDetailsQueryList()
			},

			tableCancel(item){
				if(item.pfoutDetailsState != 1){
					this.$message.error('只有待出库状态的票号才能作废')
					return
				}
				let _this = this
				const content = [item.pfoutDetailsId]
				const confirmContent = `确定要作废票号 ${item.ticketNumber} 吗？`
				this.$confirm({
					title: '作废',
					content: confirmContent,
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
						_this.apiPfoutDetailsCancel(content)
					},
					onCancel() {
						_this.$message.info('已取消操作');          
					},
				});
			},
			async apiPfoutDetailsCancel(item){
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfoutDetailsCancel, item);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.tableSelectedRows = []
					this.apiPfoutDetailsQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableBack(item){
				if(item.pfoutDetailsState != 2){
					this.$message.error('只有待激活状态的票号才能退回')
					return
				}
				let _this = this
				const ids = [item.pfoutDetailsId]
				const confirmContent = `确定要退回票号 ${item.ticketNumber} 吗？`
				this.$confirm({
					title: '退回',
					content: confirmContent,	
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
						_this.apiPfoutDetailsBack(ids)
					},
					onCancel() {
						_this.$message.info('已取消操作');          
					},
				});
			},
			async apiPfoutDetailsBack(ids){
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPfoutDetailsBack, ids);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.tableSelectedRows = []
					this.apiPfoutDetailsQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			backToUpPage(){
				console.log(this.query.pfoutCheckOutId)
				console.log(this.query.pfoutCheckInId)
				if(this.query.pfoutCheckOutId>0 && this.query.pfoutCheckInId==0){
					this.$router.push('/PfoutDraw')
				}
				if(this.query.pfoutCheckOutId==0 && this.query.pfoutCheckInId>0){
					this.$router.push('/Pfout')
				}
			},
			batchCancel() {
				// 检查是否有选中的票号
				if (this.tableSelectedRows.length === 0) {
					this.$message.warning('请选择要作废的票号');
					return;
				}
				
				// 过滤出状态为待出库(1)的票号
				const canCancel = [];
				const invalidTickets = [];
				
				this.tableSelectedRows.forEach(item => {
					if (item.pfoutDetailsState == 1) {
						canCancel.push(item.pfoutDetailsId);
					} else {
						invalidTickets.push(item.ticketNumber);
					}
				});
				
				// 检查是否有有效的票号可以作废
				if (invalidTickets.length > 0) {
					this.$message.error(`选中的票号状态异常，无法作废: ${invalidTickets.join(', ')}`);
					return
				} 
				if (canCancel.length === 0) {
					this.$message.error('请选择待出库状态的票号');
					return;
				}
				
				// 显示确认对话框
				let _this = this;
				const content = `确定要作废选中的 ${canCancel.length} 条数据吗？`;
				
				this.$confirm({
					title: '批量作废',
					content: content,
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
							_this.apiPfoutDetailsCancel(canCancel);
							// 清除选中状态
							_this.tableSelectedRows = [];
						},
						onCancel() {
							_this.$message.info('已取消操作');
						},
					});
			},
			batchBack() {
				// 检查是否有选中的票号
				if (this.tableSelectedRows.length == 0) {
					this.$message.warning('请选择要退回的票号');
					return;
				}
				
				// 过滤出状态为待激活(2)的票号
				const canBack = [];
				const invalidTickets = [];
				
				this.tableSelectedRows.forEach(item => {
					if (item.pfoutDetailsState == 2) {
						canBack.push(item.pfoutDetailsId);
					} else {
						invalidTickets.push(item.ticketNumber);
					}
				});
				
				// 检查是否有有效的票号可以退回
				if (invalidTickets.length > 0) {
					this.$message.error(`选中的票号状态异常，无法退回: ${invalidTickets.join(', ')}`);
					return
				}
				if (canBack.length === 0) {
						this.$message.error('请选择待激活状态的票号');
					return;
				}
				// 显示确认对话框
				let _this = this;
				const content = `确定要退回选中的 ${canBack.length} 条数据吗？`;
				
				this.$confirm({
					title: '批量退回',
					content: content,
					okText: '确定',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
							_this.apiPfoutDetailsBack(canBack);
							// 清除选中状态
							_this.tableSelectedRows = [];
						},
						onCancel() {
							_this.$message.info('已取消操作');
						},
					});
			},
			async exportData(){
				console.log(this.pfoutDetailsMain)
				this.exportLoading = true
				// 创建 axios 实例进行导出
				const exportHttp = axios.create({
					baseURL: this.navigation.url, // 使用统一的基础 URL
					withCredentials: true,
					headers: {
						'userToken': window.sessionStorage.getItem('token') || ''
					},
					responseType: 'blob'
				});
				const time = new Date().getTime()
				const fileName = this.pfoutDetailsMain[0].pflibraryName+'_'+this.pfoutDetailsMain[1].productName+'_'+time+'.xlsx'
				exportHttp.post(this.navigation.apiPfoutDetailsExport, this.query)
				.then(response => {
					// 检查响应是否成功
					if (response.status === 200) {
						// 创建下载链接
						const url = window.URL.createObjectURL(new Blob([response.data]))
						const link = document.createElement('a')
						link.href = url
						link.setAttribute('download', fileName)
						document.body.appendChild(link)
						link.click()
						document.body.removeChild(link)
						window.URL.revokeObjectURL(url)
						this.$message.success('下载成功')
					} else {
						this.$message.error('下载失败：服务器返回错误')
					}
				})
				.catch(error => {
					console.error('导出错误:', error)
					this.$message.error('下载失败：' + (error.message || '网络错误'))
				})
				.finally(() => {
					this.exportLoading = false
					// 可以在这里添加加载状态的处理
				})
				
			}
		},
		computed: {
			rowSelection() {
				let that = this;
				return {
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows;
					},
				};
			},
		},
		created() {
			// 读取sessionStorage中的数据
			const pfoutDetailsMain = window.sessionStorage.getItem('pfoutDetailsMain');
			if (pfoutDetailsMain) {
				const data = JSON.parse(pfoutDetailsMain);
				if (data[1]) {
					// this.pfoutId = data[1].pfoutId;
					this.query.pfoutCheckOutId = data[1].pfoutCheckOutId || 0;
					this.query.productName = data[1].productName;
					this.query.pfoutCheckInId = data[1].pfoutCheckInId || 0;
				}
				// 清除sessionStorage中的数据
				// window.sessionStorage.removeItem('pfoutLogMain');
                this.apiPfoutDetailsQueryList()
			} 
		}
	};
</script>

<style scoped>
	
</style>